module.exports = __webpack_public_path__ + "static/scale-model-of-portage-path-indian-statue-in-akron-ohio-c187feb364d2bf721bbb57194dc5dc5a.png";